import { TFunction } from 'i18next';

import { SupportRequestStatus } from '../../../types/interfaces/support-request';

export const SUPPORT_ACTIVE_STATUS_ALL = 'all';

export function getSupportRequestStatusOptions(t: TFunction) {
  return [
    {
      id: SupportRequestStatus.unprocessed,
      name: t('adminDashboard.support.status.unprocessed'),
    },
    {
      id: SupportRequestStatus.inProgress,
      name: t('adminDashboard.support.status.inProgress'),
    },
    {
      id: SupportRequestStatus.processed,
      name: t('adminDashboard.support.status.processed'),
    },
    {
      id: SupportRequestStatus.archived,
      name: t('adminDashboard.support.status.archived'),
    },
  ];
}

export function getSupportActiveStatusFilterOptions(t: TFunction) {
  return [
    {
      id: SUPPORT_ACTIVE_STATUS_ALL,
      name: t('adminDashboard.support.statusFilter.allWithoutArchived'),
    },
    {
      id: SupportRequestStatus.unprocessed,
      name: t('adminDashboard.support.status.unprocessed'),
    },
    {
      id: SupportRequestStatus.inProgress,
      name: t('adminDashboard.support.status.inProgress'),
    },
    {
      id: SupportRequestStatus.processed,
      name: t('adminDashboard.support.status.processed'),
    },
  ];
}
